import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var hasDifferentOriginAncestorFlag = false;
var sameOriginWindowChainCache = null;

function getParentWindowIfSameOrigin(w) {
  if (!w.parent || w.parent === w) {
    return null;
  } // Cannot really tell if we have access to the parent window unless we try to access something in it


  try {
    var location = w.location;
    var parentLocation = w.parent.location;

    if (location.origin !== 'null' && parentLocation.origin !== 'null') {
      if (location.protocol !== parentLocation.protocol || location.hostname !== parentLocation.hostname || location.port !== parentLocation.port) {
        hasDifferentOriginAncestorFlag = true;
        return null;
      }
    }
  } catch (e) {
    hasDifferentOriginAncestorFlag = true;
    return null;
  }

  return w.parent;
}

export var IframeUtils = /*#__PURE__*/function () {
  function IframeUtils() {
    _classCallCheck(this, IframeUtils);
  }

  _createClass(IframeUtils, null, [{
    key: "getSameOriginWindowChain",
    value:
    /**
     * Returns a chain of embedded windows with the same origin (which can be accessed programmatically).
     * Having a chain of length 1 might mean that the current execution environment is running outside of an iframe or inside an iframe embedded in a window with a different origin.
     * To distinguish if at one point the current execution environment is running inside a window with a different origin, see hasDifferentOriginAncestor()
     */
    function getSameOriginWindowChain() {
      if (!sameOriginWindowChainCache) {
        sameOriginWindowChainCache = [];
        var w = window;
        var parent;

        do {
          parent = getParentWindowIfSameOrigin(w);

          if (parent) {
            sameOriginWindowChainCache.push({
              window: w,
              iframeElement: w.frameElement || null
            });
          } else {
            sameOriginWindowChainCache.push({
              window: w,
              iframeElement: null
            });
          }

          w = parent;
        } while (w);
      }

      return sameOriginWindowChainCache.slice(0);
    }
    /**
     * Returns true if the current execution environment is chained in a list of iframes which at one point ends in a window with a different origin.
     * Returns false if the current execution environment is not running inside an iframe or if the entire chain of iframes have the same origin.
     */

  }, {
    key: "hasDifferentOriginAncestor",
    value: function hasDifferentOriginAncestor() {
      if (!sameOriginWindowChainCache) {
        this.getSameOriginWindowChain();
      }

      return hasDifferentOriginAncestorFlag;
    }
    /**
     * Returns the position of `childWindow` relative to `ancestorWindow`
     */

  }, {
    key: "getPositionOfChildWindowRelativeToAncestorWindow",
    value: function getPositionOfChildWindowRelativeToAncestorWindow(childWindow, ancestorWindow) {
      if (!ancestorWindow || childWindow === ancestorWindow) {
        return {
          top: 0,
          left: 0
        };
      }

      var top = 0,
          left = 0;
      var windowChain = this.getSameOriginWindowChain();

      var _iterator = _createForOfIteratorHelper(windowChain),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var windowChainEl = _step.value;
          top += windowChainEl.window.scrollY;
          left += windowChainEl.window.scrollX;

          if (windowChainEl.window === ancestorWindow) {
            break;
          }

          if (!windowChainEl.iframeElement) {
            break;
          }

          var boundingRect = windowChainEl.iframeElement.getBoundingClientRect();
          top += boundingRect.top;
          left += boundingRect.left;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        top: top,
        left: left
      };
    }
  }]);

  return IframeUtils;
}();